import { render, staticRenderFns } from "./ImportHorse.vue?vue&type=template&id=e8550628&"
import script from "./ImportHorse.vue?vue&type=script&lang=js&"
export * from "./ImportHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports